// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"dQ43C":[function(require,module,exports) {
require("3d12a2020f4b7896").register(require("46b5fe8813a123fd").getBundleURL("j9AQA"), JSON.parse('["j9AQA","index.js","axV5G","datasource-logger.1649b06f.js","7naDM","adapters.f9e65a28.js","anwQo","tracker.e25cbd86.js","jlq9X","ecommerce.8d616f52.js","b9P7V","impressions.23cb1b8a.js","8VFOy","tracker.4344f551.js","fLJyu","ecommerce.f0b45c73.js","5Qfmg","impressions.5ab2fc2e.js","21vB7","ecommerce.5251eedb.js","iRW28","training.815b4416.js","gBje8","exercise.41bad2fc.js","84SWA","bigcommerce.20f9df18.js","8htXI","blaze.0ee315cc.js","fzmaq","buddi.be95c29f.js","3RfNR","dispense.5161d393.js","fB1AH","drupal.1a4d3fbe.js","3Vm2O","dutchie-iframe.e5086923.js","6MrkY","dutchie-subdomain.0959a685.js","2Akq3","dutchie-plus.4cd5c394.js","abwwo","dutchie.1081fa0a.js","cZVEh","ecwid.05455177.js","4kfds","evenue.87f558ab.js","7obmm","foxy.460caa4b.js","6ZKhF","grassdoor.53bb1522.js","cGqf2","greenrush.60b11487.js","1nKuL","iqmetrix.35c66862.js","hP1un","jane.9bd204e1.js","1Oxyp","leafly.4fffca6d.js","g9DCB","lightspeed.62181fe7.js","cOu1W","magento.82950fab.js","evyIf","meadow.378e509d.js","cQnUA","olla.f2587019.js","5gSDo","shopify.32375933.js","fFwUZ","square.699bca86.js","kITDk","sticky-leaf.94fe5189.js","33j9p","sweed.3560cb9f.js","4nIw6","tymber.e0b113ae.js","hzIwG","ticketmaster.ad739252.js","bJDUo","ticketure.6b75fce7.js","4W99Z","tnew.6e2bcd6f.js","60Apv","weave.a087d8be.js","enUaf","webjoint.7cc7221c.js","gAnRu","wefunder.d1ffecd6.js","hKVfh","wix.b31b4d78.js","6hL50","woocommerce.411ae860.js","kv3Bj","yotpo.4b7e661b.js","fyzCB","flowhub.83517688.js","7Jmma","thirdparty.d3d856f2.js","1iAHB","carrot.ee1e09ac.js","gszZK","treez.8accaa24.js","9zmvw","posabit.5ca6ec54.js","kzDx5","impressions.ec7be57c.js"]'));

},{"3d12a2020f4b7896":"cH4oS","46b5fe8813a123fd":"l4KDD"}],"cH4oS":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"l4KDD":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"kheBe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
var _getAppIdTags = require("@mediajel/tracker-core/utils/get-appId-tags");
var _getContext = require("@mediajel/tracker-core/utils/get-context");
var _getContextDefault = parcelHelpers.interopDefault(_getContext);
var _getCustomTags = require("@mediajel/tracker-core/utils/get-custom-tags");
var _privacyOptOut = require("@mediajel/tracker-core/utils/privacy-opt-out");
var _privacyOptOutDefault = parcelHelpers.interopDefault(_privacyOptOut);
var _retailIdParser = require("@mediajel/tracker-core/utils/retail-id-parser");
(async ()=>{
    try {
        // Temporarily disable all logs. Set this first — before getCustomTags/getAppIdTags —
        // so their logger.info/warn calls are silenced too. Previously this ran after the
        // overrides merge, which let logs leak from the calls above it.
        (0, _logger.setLoggingEnabled)(false);
        const context = (0, _getContextDefault.default)();
        // US privacy opt-out gate — honor GPC / DNT before any tracking or network activity.
        // (getContext() above only parses the script URL — no network/cookies — so it's safe first.)
        // Lives in the tag so every embedding site inherits it. Hard no-track: we return before
        // loading adapters, Snowplow, custom tags, or appId tags — no events, no cookies.
        if ((0, _privacyOptOutDefault.default)()) {
            (0, _loggerDefault.default).debug("US privacy opt-out detected (GPC/DNT). Tracker will not initialize.");
            return;
        }
        await (0, _getCustomTags.getCustomTags)();
        await (0, _getAppIdTags.getAppIdTags)(context.appId);
        let overrides = {};
        if (window.overrides) {
            if (Array.isArray(window.overrides)) {
                // Find matching override by appId or tag (old array format)
                const matchingOverride = window.overrides.find((override)=>override.tag === context.appId || override.appId === context.appId);
                (0, _loggerDefault.default).debug(`Using default overrides for appId: ${context.appId}`);
                if (matchingOverride) overrides = matchingOverride;
            } else if (typeof window.overrides === "object" && window.overrides !== null) {
                // New format: window.overrides is an object with appId properties
                if (context.appId && window.overrides[context.appId]) {
                    overrides = window.overrides[context.appId];
                    (0, _loggerDefault.default).debug(`Using New Array overrides for appId: ${context.appId}`);
                } else {
                    // Backwards compatibility for single object override
                    overrides = window.overrides;
                    (0, _loggerDefault.default).debug(`Using default single overrides for appId: ${context.appId}`);
                }
            }
        } else {
            // Default fallback behavior
            overrides = (0, _objectSpread._)({}, context["s3.pv"] ? {} : {
                "s3.pv": "00000"
            }, context["s3.tr"] ? {} : {
                "s3.tr": "00000"
            });
            (0, _loggerDefault.default).debug(`Using default fallback overrides for appId: ${context.appId}`);
        }
        const modifiedContext = (0, _objectSpread._)({}, context, overrides);
        // Restore logging after the bootstrap silence above: getCustomTags/getAppIdTags ran quiet
        // (per the merged-in fix), now honor the `logs` flag from the query string + any
        // window.overrides. Default: logging stays on unless explicitly `logs=false`. This is also
        // what lets `debug=true` (gated on isLoggingEnabled below) actually emit.
        (0, _logger.setLoggingEnabled)(modifiedContext.logs !== "false");
        if (modifiedContext.enable === "false") {
            (0, _loggerDefault.default).debug("Tag has been disabled. Reach out to your pixel provider for more information.");
            return;
        }
        (0, _loggerDefault.default).debug("MJ Tag Context", modifiedContext);
        (0, _loggerDefault.default).debug("Integrations In Progress");
        // Validations
        if (!modifiedContext.appId) throw new Error("appId is required");
        if (modifiedContext.debug && modifiedContext.debug === "true" && (0, _logger.isLoggingEnabled)()) {
            // Debug-only datasource logging is dynamically imported so it splits into its own chunk
            // and stays out of the always-loaded index.js.
            const { datasourceLogger } = await require("480f4a0bee85376d");
            datasourceLogger();
        }
        window.parseRetailId = (0, _retailIdParser.createRetailId);
        await require("df02588cda4c8bbf").then(({ default: load })=>load(modifiedContext));
    } catch (err) {
        const clientError = `An error has occured, please contact your pixel provider: `;
        console.error(clientError + (err instanceof Error ? err.message : String(err)));
    }
})();

},{"@swc/helpers/_/_object_spread":"55zel","@mediajel/tracker-core/logger":"1YoS6","@mediajel/tracker-core/utils/get-appId-tags":"1jD17","@mediajel/tracker-core/utils/get-context":"8Fvff","@mediajel/tracker-core/utils/get-custom-tags":"1pDK9","@mediajel/tracker-core/utils/privacy-opt-out":"974Vk","@mediajel/tracker-core/utils/retail-id-parser":"cQM2K","480f4a0bee85376d":"fNKjv","df02588cda4c8bbf":"8w4Nb","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"55zel":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread);
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"2ilPd","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"2ilPd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_define_property);
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"ajuuX":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"1YoS6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setLoggingEnabled", ()=>setLoggingEnabled);
parcelHelpers.export(exports, "isLoggingEnabled", ()=>isLoggingEnabled);
parcelHelpers.export(exports, "createLogger", ()=>createLogger);
const colors = {
    debug: "color: White; background: #CB7A01; font-weight: bold; padding: 1px 4px; border-radius: 3px;",
    info: "color: White; background: #388AB8; font-weight: bold; padding: 1px 4px; border-radius: 3px;",
    warn: "color: White; background: #F26430; font-weight: bold; padding: 1px 4px; border-radius: 3px;",
    error: "color: White; background: #AD343E; font-weight: bold; padding: 1px 4px; border-radius: 3px;"
};
const parseMsgToString = (message)=>{
    if (typeof message === "string" || typeof message === "number") return message.toString();
    else if (Array.isArray(message)) return message.map(parseMsgToString).join(" ");
    else return JSON.stringify(message, null, 2);
};
const formatMessage = (level, name, label, message)=>{
    const timestamp = new Date().toISOString();
    const identifier = label ? `${name} - ${label}` : name;
    return `${timestamp} [${identifier}] ${level.toUpperCase()} : ${message}`;
};
// Reads the `logs` query-string flag off the tag's own <script src>. Mirrors the
// parsing in utils/get-context.ts but kept self-contained and dependency-free so it
// can run at the earliest possible point — this module is index.ts's first import,
// so the flag is resolved before any other tracker code executes.
const readLogsEnabled = ()=>{
    try {
        const scripts = document.getElementsByTagName("script");
        const target = document.currentScript || scripts[scripts.length - 1];
        var _target_src;
        const src = (_target_src = target === null || target === void 0 ? void 0 : target.src) !== null && _target_src !== void 0 ? _target_src : "";
        const queryIndex = src.indexOf("?");
        if (queryIndex === -1) return true; // opt-out default: logging on unless explicitly disabled
        return new URLSearchParams(src.substring(queryIndex)).get("logs") !== "false";
    } catch (e) {
        return true; // fail-safe: never let log setup break the tracker
    }
};
// Single source of truth for whether the tracker emits any console output.
// Initialized from the query string at module load (earliest point); can be
// re-applied later (e.g. after window.overrides merge) via setLoggingEnabled.
let enabled = readLogsEnabled();
const setLoggingEnabled = (value)=>{
    enabled = value;
};
const isLoggingEnabled = ()=>enabled;
const createLogger = (name)=>{
    let label = null;
    const log = (level, ...message)=>{
        if (!enabled) return;
        const formattedMessage = formatMessage(level, name, label, parseMsgToString(message));
        const colorStyle = colors[level] || "";
        console.log(`%c${formattedMessage}`, colorStyle);
    };
    return {
        setLabel: (newLabel)=>{
            label = newLabel;
        },
        debug: (...message)=>log("debug", ...message),
        info: (...message)=>log("info", ...message),
        warn: (...message)=>log("warn", ...message),
        error: (...message)=>log("error", ...message)
    };
};
const logger = createLogger("MJ");
exports.default = logger;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"1jD17":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAppIdTags", ()=>getAppIdTags);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
const getAppIdTags = async (appId)=>{
    var error;
    return;
};

},{"@mediajel/tracker-core/logger":"1YoS6","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"8Fvff":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
// Locates our tag
//* v2
//* v1
const getContext = ()=>{
    const scripts = document.getElementsByTagName("script");
    const target = document.currentScript || scripts[scripts.length - 1];
    const substring = target.src.substring(target.src.indexOf("?"));
    const urlSearchParams = new URLSearchParams(substring);
    const _Object_fromEntries = Object.fromEntries(urlSearchParams.entries()), { mediajelAppId, appId, version } = _Object_fromEntries, params = (0, _objectWithoutProperties._)(_Object_fromEntries, [
        "mediajelAppId",
        "appId",
        "version"
    ]);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, params), {
        appId: appId || mediajelAppId || "",
        version: version || "1",
        environment: params.environment || "production",
        collector: "collector.dmp.mediajel.ninja",
        // Regex mainly used to remove the "&amp;" and the '\\"' from the outerHTML
        tag: target.outerHTML.replace(/&amp;/g, "&").replace(/\\"/g, '"')
    });
};
exports.default = getContext;

},{"@swc/helpers/_/_object_spread":"55zel","@swc/helpers/_/_object_spread_props":"kykPq","@swc/helpers/_/_object_without_properties":"hfZg3","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"kykPq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread_props);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"hfZg3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_without_properties);
var _objectWithoutPropertiesLooseJs = require("./_object_without_properties_loose.js");
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, _objectWithoutPropertiesLooseJs._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./_object_without_properties_loose.js":"37Td3","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"37Td3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_without_properties_loose);
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"1pDK9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCustomTags", ()=>getCustomTags);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
const getCustomTags = async ()=>{
    var error;
    return;
};

},{"@mediajel/tracker-core/logger":"1YoS6","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"974Vk":[function(require,module,exports) {
/**
 * Detects US privacy opt-out signals at the browser level.
 *
 * Honors Global Privacy Control (GPC) — the opt-out signal legally recognized
 * under California's CCPA/CPRA and in Colorado and Connecticut — plus legacy
 * Do Not Track (DNT) as a fallback. Read directly from the browser; no consent
 * banner, cookie, or per-site integration is involved.
 *
 * @returns true if the visitor has signaled a privacy opt-out.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUsPrivacyOptOut", ()=>isUsPrivacyOptOut);
const isDntEnabled = (value)=>value === "1" || value === "yes";
const isUsPrivacyOptOut = ()=>{
    const gpcOptOut = navigator.globalPrivacyControl === true;
    // Check each DNT source independently — a truthy-but-not-opt-out value from one
    // source (e.g. "0") must not mask an opt-out signal from another.
    const dntOptOut = isDntEnabled(navigator.doNotTrack) || isDntEnabled(navigator.msDoNotTrack) || isDntEnabled(window.doNotTrack);
    return gpcOptOut || dntOptOut;
};
exports.default = isUsPrivacyOptOut;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"cQM2K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRetailId", ()=>createRetailId);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
var _pollForElement = require("../sources/utils/poll-for-element");
var _guard = require("@mediajel/tracker-core/utils/guard");
const createRetailId = (retail)=>{
    const { id } = retail;
    const parseRetailId = ()=>{
        id.forEach((retail)=>{
            (0, _pollForElement.pollForElement)(retail.element, ()=>{
                if (!retail.element) return;
                const baseUrl = window.location.href;
                const url = new URL(baseUrl);
                const urlId = retail.retailId.replace(/\s+/g, "").toLowerCase();
                retail.element.forEach((elementSelector)=>{
                    const element = document.querySelector(elementSelector);
                    if (element) (0, _loggerDefault.default).debug(`Element detected for retail ID "${retail.retailId}": ${elementSelector}`);
                });
                url.searchParams.set("retailId", urlId);
                window.history.replaceState({}, "", url.toString());
                if (retail.fn) retail.fn();
            });
        });
    };
    parseRetailId();
    const checkUrlChange = ()=>{
        var _window_navigation;
        (_window_navigation = window.navigation) === null || _window_navigation === void 0 ? void 0 : _window_navigation.addEventListener("navigate", (0, _guard.guard)(()=>{
            let previousUrl = sessionStorage.getItem("previousUrl");
            const currentUrl = window.location.href;
            sessionStorage.setItem("currentUrl", currentUrl);
            if (currentUrl !== previousUrl) {
                sessionStorage.setItem("previousUrl", currentUrl);
                parseRetailId();
            }
        }, "retail-navigate"));
    };
    setInterval((0, _guard.guard)(checkUrlChange, "retail-poll"), 1000);
};

},{"@mediajel/tracker-core/logger":"1YoS6","../sources/utils/poll-for-element":"eIoH9","@mediajel/tracker-core/utils/guard":"8CHY0","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"eIoH9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pollForElement", ()=>pollForElement);
var _guard = require("@mediajel/tracker-core/utils/guard");
const pollForElement = (selectors, callback, interval = 100, timeout = 30000)=>{
    const startTime = Date.now();
    const poller = setInterval(()=>{
        const elements = selectors.map((selector)=>{
            const element = document.querySelector(selector);
            return element !== null;
        });
        const isAllLoaded = elements.every(Boolean);
        if (isAllLoaded) {
            clearInterval(poller);
            (0, _guard.guard)(callback, "poll-for-element")();
        } else if (Date.now() - startTime >= timeout) clearInterval(poller);
    }, interval);
};

},{"@mediajel/tracker-core/utils/guard":"8CHY0","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"8CHY0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "guard", ()=>guard);
var _logger = require("@mediajel/tracker-core/logger");
var _loggerDefault = parcelHelpers.interopDefault(_logger);
const guard = (fn, label = "callback")=>{
    return function(...args) {
        try {
            return fn.apply(this, args);
        } catch (err) {
            (0, _loggerDefault.default).error(`Tracker callback "${label}" threw and was suppressed:`, err);
            return undefined;
        }
    };
};
exports.default = guard;

},{"@mediajel/tracker-core/logger":"1YoS6","@parcel/transformer-js/src/esmodule-helpers.js":"ajuuX"}],"fNKjv":[function(require,module,exports) {
module.exports = require("7a35274a2c26dbe")(require("851238af747119d4").resolve("axV5G")).then(()=>module.bundle.root("iwSAi"));

},{"7a35274a2c26dbe":"auCaP","851238af747119d4":"cH4oS"}],"auCaP":[function(require,module,exports) {
"use strict";
var cacheLoader = require("95cdd300a2317c");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"95cdd300a2317c":"1nIxg"}],"1nIxg":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"8w4Nb":[function(require,module,exports) {
module.exports = require("c982fe5249281a2")(require("d0fd5607aa7311b8").resolve("7naDM")).then(()=>module.bundle.root("62rPl"));

},{"c982fe5249281a2":"auCaP","d0fd5607aa7311b8":"cH4oS"}]},["dQ43C","kheBe"], "kheBe", "parcelRequire07df")

//# sourceMappingURL=index.js.map
